@if (!_store.isEmbeddedSg()) {
  <widget-container>
    <!-- Pass custom actions to the widget-table component -->
    <ng-content select="[customActions]"></ng-content>
  </widget-container>
} @else {
  <embedded-container />
}
